import HrBasic from "./HrBasic";
import HrBoostUp from "./HrBoostUp";
import moment from "moment";
import queryString from "query-string";

export default function Hr() {
  const today = moment().format("YYYY-MM-DD");
  const { ccid, kiosk_id } = queryString.parse(window.location.search);

  // Event
  if (ccid == 7 && today >= "2025-04-07" && today <= "2025-04-30") {
    return <HrBoostUp />;
  }

  if (
    ccid == 4 &&
    moment().format("YYYY-MM-DD HH:mm") >= "2025-04-08 07:00" &&
    today <= "2025-04-30"
  ) {
    return <HrBoostUp />;
  }

  return <HrBasic />;
}
